import {
  CustomFieldSettingOrder,
  CustomFieldSettingOrderInput,
} from '@user/store/customFieldSettings'
import { ICustomFieldFormSetting } from '@user/store/entityFormSettings'

export const settingsToInput = (
  settings: ICustomFieldFormSetting[],
  entityType: number,
): CustomFieldSettingOrderInput => {
  return {
    entityType: entityType,
    customFieldSettingOrders: settings.map(
      ({ customFieldId, order }): CustomFieldSettingOrder => ({
        id: customFieldId,
        order: order,
      }),
    ),
  }
}
